import React from "react";

export default function UCTable({ columns, rows, rowKey }) {
  return (
    <div className="ac-uc-tablewrap">
      <table className="ac-uc-table">
        <colgroup>
          {columns.map((c) => (
            <col
              key={c.key}
              style={c.width ? { width: c.width, minWidth: c.width } : undefined}
            />
          ))}
        </colgroup>

        <thead>
          <tr>
            {columns.map((c) => (
              <th
                key={c.key}
                className={c.headerClassName || c.className || ""}
                style={c.headerStyle || c.style}
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((r) => (
            <tr key={rowKey(r)}>
              {columns.map((c) => (
                <td
                  key={c.key}
                  className={c.cellClassName || c.className || ""}
                  style={c.cellStyle || c.style}
                >
                  {c.render ? c.render(r) : r[c.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}